import { api } from './client'
import type { components } from './generated/schema'

// M-44 — trả hàng đơn đã giao + lựa chọn hoàn tiền. Types sinh từ OpenAPI.
export type RefundChoice = components['schemas']['RefundChoice']
export type RefundMode = RefundChoice['mode']
export type SalesReturn = components['schemas']['SalesReturn']
export type ReturnableResponse = components['schemas']['ReturnableResponse']
export type ReturnableItem = components['schemas']['ReturnableItem']
export type ReturnableLot = components['schemas']['ReturnableLot']
export type ReturnPreviewRequest = components['schemas']['ReturnPreviewRequest']
export type ReturnPreviewResponse =
    components['schemas']['ReturnPreviewResponse']
export type CreateSalesReturnRequest =
    components['schemas']['CreateSalesReturnRequest']
export type CustomerRefundRequest =
    components['schemas']['CustomerRefundRequest']
export type CustomerRefund = components['schemas']['CustomerRefund']

export const salesReturnApi = {
    returnable: (orderId: string) =>
        api.get<ReturnableResponse>(`/sales-orders/${orderId}/returnable`),
    preview: (orderId: string, data: ReturnPreviewRequest) =>
        api.post<ReturnPreviewResponse>(
            `/sales-orders/${orderId}/returns/preview`,
            data,
        ),
    create: (orderId: string, data: CreateSalesReturnRequest) =>
        api.post<SalesReturn>(`/sales-orders/${orderId}/returns`, data),
    list: (orderId: string) =>
        api.get<SalesReturn[]>(`/sales-orders/${orderId}/returns`),
    refundCustomer: (customerId: string, data: CustomerRefundRequest) =>
        api.post<CustomerRefund>(`/customers/${customerId}/refunds`, data),
}
